const LogRocket = require('logrocket');

exports.onClientEntry = () => {
  if (process.env.GATSBY_ENV !== 'DEV') {
    LogRocket.init('dzkzto/website-dq4q7');
  }
};
